import { render, staticRenderFns } from "./fix-worker.vue?vue&type=template&id=37984b48&"
import script from "./fix-worker.vue?vue&type=script&lang=js&"
export * from "./fix-worker.vue?vue&type=script&lang=js&"
import style0 from "./fix-worker.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports